import { useEffect } from 'react'
import dashedLine from '../images/dashed-curved-toggle-line.svg'
import { select } from 'd3'

type Screen4Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const Screen4 = ({ anchorRef }: Screen4Props) => {
  const { x, y } = anchorRef.current?.getBoundingClientRect()!
  useEffect(() => {
    const currentRef = anchorRef.current
    select(currentRef).style('z-index', 1000)
    return () => {
      select(currentRef).style('z-index', 'initial')
    }
  }, [])
  return (
    <div className="flex h-full bg-[#222222] opacity-[.78] w-screen relative">
      <div
        className="flex flex-col items-center w-[330px] gap-4 absolute"
        style={{
          left: `${x - 330}px`,
          top: `${y - 180}px`,
        }}
      >
        <p className="text-orange font-decimal text-[20px]">
          Use this toggle to view all organizations data
        </p>
        <img src={dashedLine} alt="dashed line" className="self-end" />
      </div>
    </div>
  )
}
export default Screen4
